import React, { Suspense, lazy } from "react";
import { Navigate } from "react-router";
import { ReactComponent as Icon1 } from "@/static/image/backManagement/menu_icon1.svg";
import ScanWebRouter from "./ScanWeb/router";

const BackManagement = lazy(() => import("@/views/BackManagement"));

const withSuspense = (element) => (
    <Suspense fallback={null}>
        {element}
    </Suspense>
);

const BackManagementRouter = [
    {
        path: "/management",
        key: "view",
        hide: true,
        element: <Navigate to="/app/android/list" />,
    },
    {
        path: "/app",
        title: "Security Hardening",
        key: "app",
        hide: false,
        icon: <Icon1 />,
        element: withSuspense(<BackManagement />),
        children: [...ScanWebRouter],
    },
];
export default BackManagementRouter;
